import {Component, OnInit} from '@angular/core';
import {User} from '../../data-access-layer/interfaces/users.interface'
import {UserService} from '../../data-access-layer/services/users.service';
import {MatDialog} from '@angular/material/dialog';
import {UserDialogComponent} from './add_user.component';
import {AuthService} from '../../data-access-layer/services/auth.service';
import { AlertService } from '../../data-access-layer/services/alert.service';

@Component({
  selector: 'app-root',
  templateUrl: '../templates/administration.component.html',
  styleUrl: '../templates/styles/administration.component.css',
  standalone: false
})

export class AdministrationComponent implements OnInit {
  public users: User[] = [];

  public showDeleteButtons = false;
  public open: boolean = false;
  userNameSearch: string = ''
  public isAdmin = false;
  roles = [
    {userRole: 'Администратор'},
    {userRole: 'Пользователь'}
  ]
    selectedUser: User | any;

  constructor(private userService: UserService, private dialog: MatDialog, private authService: AuthService, private alertService: AlertService) {
  }

  getUsers(): void {
    this.userService.getAllUsers().subscribe((response) => {
      this.users = response.users;

      this.selectedUser = this.users[0];
    });
  }

  ngOnInit(): void {
    this.getUsers();
    this.isAdmin = this.authService.isAdmin();
  }

  adduser(): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: 'min(950px, 95vw)',
      maxWidth: '95vw',
      height: 'min(420px, 85vh)',
      maxHeight: '90vh',
      data: {name: 'Имя пользователя'}
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getUsers();
    });
  }

  search(): void {
    if (!this.userNameSearch)
      this.getUsers();
    const searchRegex = new RegExp(this.userNameSearch, 'i');
    const filteredUsers = this.users.filter(user => searchRegex.test(user.userName));
    this.users = filteredUsers;
  }

  toggleDeleteMode(): void {
    this.showDeleteButtons = !this.showDeleteButtons;
  }

  deleteUser(user: User): void {
    this.alertService.confirm({
      title: 'Удаление пользователя',
      message: `Вы уверены, что хотите удалить пользователя "${user.userName}"?`,
      confirmButtonText: 'Да',
      cancelButtonText: 'Отмена',
    }).subscribe((confirmed) => {
      if (confirmed) {
        const requestDelete = {
          Id: user.userId
        };
        this.userService.deleteUser(requestDelete).subscribe(() => {
          this.getUsers();
        });
      }
    });
  }


  onRoleChange(newRole: string, user: any) {
    const requestUpdate = {
      Id: user.userId,
      Role: newRole,
      Password: user.userPassword
    }
    this.userService.updateUser(requestUpdate).subscribe(() => {
      this.getUsers();
    });
  }

  toggleOpen(user: User) {
    if (this.selectedUser === user)
      this.open = !this.open;
  }

  selectUser(user: User) {
    this.selectedUser = user;
  }
}
